import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ButtonComponent } from './shared/components/ui/button/button.component';
import { ConfirmDialogService } from './shared/service/confirm-dialog.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, ConfirmDialogModule, ToastModule, ButtonComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'SIAE';

  readonly confirmDialogService = inject(ConfirmDialogService);
}
